import { render, staticRenderFns } from "./ViajesDetViaje.vue?vue&type=template&id=e83ad330"
import script from "./ViajesDetViaje.vue?vue&type=script&lang=js"
export * from "./ViajesDetViaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports